// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3262":"f0fbc32f","8940":"5c88e76e"}[chunkId] + ".chunk.css";
};